import React from "react";
import styled from "styled-components";
import { Button, Input } from "../../design-system";
import { toast } from "react-toastify";

import { importDataWithCNPJ } from "../../api/branches";

const SearchButton = styled(Button)`
  height: 42px;
  width: 42px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  i {
    font-size: 16px;
  }
`;

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  function onClick() {
    const cnpjStr = props.cnpj || "";
    const cleanCnpj = cnpjStr.replace(/\D/g, "");
    
    if (cleanCnpj.length !== 14) {
      toast.warn("Por favor, digite um CNPJ completo para realizar a busca.");
      return;
    }

    setLoading(true);
    importDataWithCNPJ(cleanCnpj, props.type)
      .then((resp) => {
        if (props.onSuccess) {
          props.onSuccess(resp);
        }
      })
      .catch((error) => {
        console.debug(error);
        if (error.invalid_cnpj) {
          const invalidMsg = Array.isArray(error.invalid_cnpj) ? error.invalid_cnpj[0] : error.invalid_cnpj;
          if (invalidMsg.includes("CNPJ situation:")) {
            const [_, msg] = invalidMsg.split("CNPJ situation:");
            toast.error(`ERRO: O CNPJ encontra-se com a situação: ${msg}`.toUpperCase());
            return;
          } else if (invalidMsg.includes("Invalid CNPJ")) {
            toast.error("CNPJ INVÁLIDO");
            return;
          }
        } else if (error.rate_limit) {
          toast.warn("FALHA NA CONSULTA. TENTE NOVAMENTE EM 15 SEGUNDOS!");
        } else if (error.cnae_error) {
          toast.error("CÓDIGO CNAE NÃO LOCALIZADO");
        } else if (error.cnpj_error) {
          const errMsg = Array.isArray(error.cnpj_error) ? error.cnpj_error[0] : error.cnpj_error;
          toast.warn(errMsg);
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }
  return (
    <div className="d-flex align-items-end w-100">
      <div style={{ flex: 1 }}>
        <Input
          label={props.label !== undefined ? props.label : "CNPJ"}
          disabled={loading || props.disabled}
          value={props.value !== undefined ? props.value : (props.cnpj || "")}
          onChange={props.onChange}
          type="cnpj"
          name={props.name || "cnpj"}
          placeholder={props.placeholder || "Insira aqui o CNPJ"}
          id={props.id}
        />
      </div>
      <div style={{ marginLeft: '8px' }}>
        <SearchButton variant="secondary" disabled={loading || props.disabled} onClick={onClick}>
          {loading ? (
            <i className="fas fa-spinner fa-pulse" />
          ) : (
            <i className="fas fa-search" />
          )}
        </SearchButton>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/_components/ImportCNPJ/index.jsx